import { getPublicFAQUrl } from '@shared/configs/configs/config';

import HealthConditions from '../components/HealthConditions';
import HighlightsAndInsights from '../components/HighlightsAndInsights';
import MedicationsDevicesTreatment from '../components/MedicationsDevicesTreatment';
import SupportAndTools from '../components/SupportAndTools';
import WellBeingAndLifestyle from '../components/WellBeingAndLifestyle';

export const useHeaderMenu = () => {
  const headerMenu = [
    {
      component: <HighlightsAndInsights />,
      label: 'Highlights & Insights',
    },
    {
      component: <HealthConditions />,
      label: 'Health Conditions',
    },
    {
      component: <MedicationsDevicesTreatment />,
      label: 'Medications, Devices & Treatments',
    },
    {
      component: <WellBeingAndLifestyle />,
      label: 'Well-being & Lifestyle',
    },
    {
      component: <SupportAndTools />,
      label: 'Support & Tools',
    },
  ];

  const subHeaderMenu = [
    {
      isPublic: false,
      label: 'Health e-Services',
      url: '/',
    },
    {
      isPublic: true,
      label: 'Healthcare Directory',
      url: '',
    },
    {
      isPublic: true,
      label: 'Help Centre',
      url: `${getPublicFAQUrl()}/hc/en-us`,
    },
  ];

  const mobileMenu = [
    {
      label: 'Healthcare Directory',
      url: '',
    },
    {
      label: 'Help Centre',
      url: `${getPublicFAQUrl()}/hc/en-us`,
    },
  ];

  return {
    headerMenu,
    mobileMenu,
    subHeaderMenu,
  };
};
